import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/sign-up/list',
        data,
        method: 'post'
    })
};
// 
export const setStatus = (params) => {

    let data = qs.stringify(params)
    return axios.request({
        url: '/sign-up/contract',
        data,
        method: 'post'
    })
};